import { useDispatch } from "react-redux";
import styles from "./styles.module.css";
import global from "../../app.module.css";
import RMApp from "../../modules/rickmorty";
import PokeApp from "../../modules/pokemon";
import { useEffect } from "react";

function HomeComponent(props) {
    console.log('HomeComponent.start');

    return ( 
        <div className={`${styles.contenedor} ${global.background}`}>
            <div id="rickmorty">
                <RMApp />
            </div>
            <div id="pokemon">
                <PokeApp />
            </div>
        </div>
    );
}

export default HomeComponent;